import { CommonModule, NgIf } from '@angular/common'
import { Component, OnInit, ViewChild } from '@angular/core'
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms'
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons'
import {
  DateInputFillMode,
  DatePickerComponent,
} from '@progress/kendo-angular-dateinputs'
import {
  KENDO_DROPDOWNLIST,
  MultiSelectComponent,
  TagTemplateDirective,
} from '@progress/kendo-angular-dropdowns'
import {
  ColumnComponent,
  ExcelExportComponent,
  KENDO_EXCELEXPORT,
} from '@progress/kendo-angular-excel-export'
import { KENDO_GRID } from '@progress/kendo-angular-grid'
import {
  CheckBoxDirective,
  RadioButtonDirective,
} from '@progress/kendo-angular-inputs'
import { LabelComponent } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { ReportsService } from '../../@theme/services/reports.service'
@Component({
  selector: 'gd-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  imports: [
    CommonModule,
    KENDO_DROPDOWNLIST,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    RadioButtonDirective,
    /*        LabelDirective, */
    MultiSelectComponent,
    LabelComponent,
    TagTemplateDirective,
    DatePickerComponent,
    CheckBoxDirective,
    KENDO_GRID,
    KENDO_BUTTON,
    KENDO_EXCELEXPORT,
    ColumnComponent,
    /*       CellTemplateDirective, */
    /*    DatePipe, */
  ],
})
export class ReportsComponent implements OnInit {
  public selectedFillMode: DateInputFillMode = 'solid'
  public formbutton = false
  public fillModes: DateInputFillMode[] = ['solid', 'flat', 'outline']
  public defaultDropdownItem = { text: 'Select a Report', value: null }
  gridExcelexportDeleted: any[] = []
  public reportTypes = [
    { text: 'Rep Reports', value: 8 },
    { text: 'Account Form Report', value: 1 },
    { text: 'Commission Report', value: 2 },
    { text: 'VA Age Report', value: 3 },
    /*  { text: 'All Transactions Report', value: 4 }, */
    { text: 'Non-Rep Entered Transactions', value: 5 },
    /* { text: 'Summary of Non-Rep Entered Transactions', value: 6 }, */
    { text: 'VA Summary Report', value: 9 },
    { text: 'Deleted Blotter Transactions', value: 10 },
  ]
  ngModelDate = new Date()
  ngModelendDate = new Date()
  public newreplist: any[]
  public repList: any[]
  public repListBase: any[]
  public crdBranches: any[]
  public crdBranchesBase: any[]
  private currentDate = new Date()
  private thirtyDaysAgo = new Date(
    this.currentDate.setDate(this.currentDate.getDate() - 30),
  )
  public selectedReportType: number
  public selectedReportTypeSettings: FormFieldSettings
  public showTransactionFilterSelection = false
  public selectedTransactionFilter: 'All' | 'Trading' | 'AnnuitiesLife' = 'All'

  // Declare enums to use in html
  public searchBySelectionEnum = SearchBySelectionEnum
  public searchReportTypeEnum = SearchReportTypeEnum
  public searchReportFileTypeEnum = SearchReportFileTypeEnum

  private reportForm: UntypedFormGroup

  // Kendo export used for the Non-Rep Entered Transactions report (selection 5).
  @ViewChild('excelexportNonRep') excelexportNonRep: ExcelExportComponent

  constructor(
    private reportService: ReportsService,
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
  ) {
    const today = new Date()
    this.ngModelDate = this.thirtyDaysAgo
    this.ngModelendDate = today
  }

  ngOnInit() {
    this.reportService.getRepListShort().subscribe((response) => {
      this.repList = response
      this.repListBase = response
      // Default to All Reps: preselect every rep once the list is loaded.
      if (
        this.reportForm &&
        this.reportForm.value['searchBySelection'] ===
          SearchBySelectionEnum.SearchByAll
      ) {
        this.reportForm.controls['selectedReps'].setValue(
          this.repListBase ? [...this.repListBase] : [],
        )
      }
    })
    this.reportService.getCrdBranchShort().subscribe((response) => {
      this.crdBranches = response
      this.crdBranchesBase = response
    })
    this.reportService.getCurrentRole().subscribe((response) => {
      const role = response
      if (
        role === 'REP' ||
        role === 'BRANCH MANAGER' ||
        role === 'BRANCH ACCESS NON MANAGER'
      ) {
        this.reportTypes.push({
          text: 'All Transactions Report Short',
          value: 7,
        })
      }
    })
    this.selectedReportType = Number(localStorage.getItem('selectedReportType'))
    if (this.selectedReportType) {
      this.selectedReportTypeSettings = new FormFieldSettings(
        this.selectedReportType,
      )
    }
    this.reportForm = this.formBuilder.group({
      selectedReport: [null],
      startDate: [new Date()],
      endDate: [new Date()],
      searchBySelection: SearchBySelectionEnum.SearchByAll,
      searchReportType: SearchReportTypeEnum.AccountReport,
      searchReportFileType: SearchReportFileTypeEnum.Excel,
      selectedCrdBranches: [],
      selectedReps: [],
    })

    if (this.selectedReportType === 10) {
      this.formbutton = true
    } else {
      this.formbutton = false
    }
  }

  reportTypeChange(event: any) {
    if (!this.selectedReportType) {
      this.selectedReportTypeSettings = null
      localStorage.removeItem('selectedReportType')
      return
    }
    this.selectedReportTypeSettings = new FormFieldSettings(
      this.selectedReportType,
    )
    localStorage.setItem('selectedReportType', '' + this.selectedReportType)
    if (this.selectedReportType === 10) {
      this.formbutton = true
    } else {
      this.formbutton = false
    }
  }

  onFormSubmit(event: any) {
    switch (this.selectedReportType) {
      case 1:
        this.reportService
          .getAccountFormReport({
            repId: 0,
            branchNumber: '',
            reportNumber: Number(this.reportForm.value['selectedReport']),
          })
          .subscribe((response) => {
            this.downloadFile(response, 'AccountFormReportExport.csv')
          })
        break
      case 2:
        this.reportService
          .getCommissionReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
          })
          .subscribe((response) => {
            this.downloadFile(response, 'CommissionExport.csv')
          })
        break
      case 3:
        this.reportService
          .getVaAgeReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
          })
          .subscribe((response) => {
            this.downloadFile(response, 'VaAgeReport.csv')
          })
        break
      /*  case 4:
        this.reportService
          .getBlotterReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
            reportTypeId: 1,
          })
          .subscribe((response) => {
            this.downloadFile(response, 'AllTransactionReport.csv')
          })
        break */
      case 5:
        this.reportService
          .getBlotterReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
            reportTypeId: 2,
          })
          .subscribe((response) => {
            // The Non-Rep data arrives as a server-generated CSV. Parse it into row
            // objects (keyed by the CSV header names), feed the Non-Rep Kendo export
            // and save it so the column order defined in the template is applied.
            response
              .text()
              .then((csvText: string) => {
                const rows = this.csvToObjects(csvText)
                if (rows.length === 0) {
                  this.showToast(
                    'error',
                    'Sorry there is no data. Please choose a date further back.',
                  )
                  return
                }
                this.gridExcelexportDeleted = rows
                this.showToast(
                  'success',
                  'Please wait, your Excel is being downloaded.',
                )
                // Save directly (no alternate-row shading) for the Non-Rep export.
                setTimeout(() => this.excelexportNonRep.save(), 500)
              })
              .catch((err: any) => {
                console.error('Failed to build Non-Rep export:', err)
                this.showToast(
                  'error',
                  'Failed to build the Non-Rep report. Please try again.',
                )
              })
          })
        break
      case 6:
        this.reportService
          .getvaribleAnnunityAge({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
            reportTypeId: 2,
          })
          .subscribe((response) => {
            this.downloadFile(response, 'VaruableAnnuityAgeExport.csv')
          })
        break
      case 7:
        this.reportService
          .getBlotterShortReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
            reportTypeId: 2,
          })
          .subscribe((response) => {
            this.downloadFile(response, 'RepFeeReport.csv')
          })
        break
      case 10:
        this.ExportToExcelDeletednow()
        break
      case 9:
        this.reportService
          .getVaSummaryReport({
            repId: 0,
            branchNumber: '',
            startDate: this.reportForm.value['startDate'],
            endDate: this.reportForm.value['endDate'],
            reportTypeId: 2,
          })
          .subscribe((response) => {
            this.downloadFile(response, 'VaSummaryReport.csv')
          })
        break
      case 8: {
        for (
          let i = 0, len = this.reportForm.value['selectedReps'].length;
          i < len;
          i++
        ) {
          // delete this.reportForm.value['selectedReps'][i].fullName
        }
        const datareturn = this.reportForm.value['selectedReps'].map(
          (x) => x.repId,
        )
        // selectedCrdBranches holds CrdBranchShortDto objects, but the backend
        // expects List<string>. Project down to just the branch numbers, matching
        // the pattern used above for selectedReps -> repId.
        const crdBranchNumbers = (
          (this.reportForm.value['selectedCrdBranches'] as any[]) || []
        ).map((x) => (typeof x === 'string' ? x : x?.crdBranchNumber))
        const request = {
          repId: 0,
          branchNumber: '',
          startDate: this.reportForm.value['startDate'],
          endDate: this.reportForm.value['endDate'],
          crdBranchNumbers: crdBranchNumbers,
          repIds: datareturn,
          reportTypeId: 3,
          reportFilter: this.selectedTransactionFilter,
        }
        if (
          this.reportForm.value['searchReportFileType'] ===
          SearchReportFileTypeEnum.Pdf
        ) {
          if (
            this.reportForm.value['searchReportType'] ===
            SearchReportTypeEnum.AccountReport
          ) {
            this.reportService
              .getAccountReportPdf(request)
              .subscribe((response) => {
                this.downloadFile(response, 'PdfReport.pdf')
              })
          } else {
            this.reportService
              .getTransactionReportPdf(request)
              .subscribe((response) => {
                this.downloadFile(response, 'PdfReport.pdf')
              })
          }
        } else {
          if (
            this.reportForm.value['searchReportType'] ===
            SearchReportTypeEnum.AccountReport
          ) {
            this.reportService
              .getAccountReportExcel(request)
              .subscribe((response) => {
                this.downloadFile(response, 'ExcelReport.csv')
              })
          } else {
            this.reportService
              .getTransactionReportExcel(request)
              .subscribe((response) => {
                this.downloadFile(response, 'ExcelReport.csv')
              })
          }
        }
        break
      }
    }
  }

  getAccessExportreports(component) {
    const Param = {
      Startdate: this.reportForm.value['startDate'],
      Enddate: this.reportForm.value['endDate'],
    }
    this.reportService.getDeletedBlottersReports(Param).subscribe((r) => {
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  ExportToExcelDeletednow() {
    this.formbutton = true
  }
  ExportToExcelDeleted(component) {
    this.showToast('success', 'Please wait, We are retrieving your information')
    this.getAccessexportreports(component)
  }
  downloadFile(file: Blob, fileName: string) {
    const url = window.URL.createObjectURL(file)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.click()
    URL.revokeObjectURL(url)
  }

  /**
   * Parses a CSV string into an array of row objects keyed by the header names
   * (trimmed). Used to feed the Non-Rep Kendo export, whose column `field`
   * attributes match these header keys. Handles quoted fields that contain commas,
   * doubled quotes and embedded newlines.
   */
  private csvToObjects(csvText: string): any[] {
    const rows = this.parseCsv(csvText)
    if (rows.length < 2) {
      return []
    }

    const header = rows[0].map((h) => (h ?? '').trim())
    const objects: any[] = []
    for (let r = 1; r < rows.length; r++) {
      const row = rows[r]
      // Skip stray empty lines some CSV writers append.
      if (row.length === 1 && row[0] === '') {
        continue
      }
      const obj: any = {}
      header.forEach((name, i) => {
        if (name !== '') {
          obj[name] = i < row.length ? row[i] : ''
        }
      })
      objects.push(obj)
    }
    return objects
  }

  /** Minimal RFC 4180 CSV parser: returns rows, each an array of field strings. */
  private parseCsv(text: string): string[][] {
    const rows: string[][] = []
    let field = ''
    let row: string[] = []
    let inQuotes = false
    let i = 0
    const n = text.length
    while (i < n) {
      const ch = text[i]
      if (inQuotes) {
        if (ch === '"') {
          if (text[i + 1] === '"') {
            field += '"'
            i += 2
            continue
          }
          inQuotes = false
          i++
          continue
        }
        field += ch
        i++
        continue
      }
      if (ch === '"') {
        inQuotes = true
        i++
        continue
      }
      if (ch === ',') {
        row.push(field)
        field = ''
        i++
        continue
      }
      if (ch === '\r') {
        row.push(field)
        field = ''
        rows.push(row)
        row = []
        i += text[i + 1] === '\n' ? 2 : 1
        continue
      }
      if (ch === '\n') {
        row.push(field)
        field = ''
        rows.push(row)
        row = []
        i++
        continue
      }
      field += ch
      i++
    }
    if (field !== '' || row.length > 0) {
      row.push(field)
      rows.push(row)
    }
    return rows
  }

  multiSelectValueChange(searchType: SearchBySelectionEnum) {
    switch (searchType) {
      case SearchBySelectionEnum.SearchByBranch: {
        const selectedCrdBranches = this.reportForm.controls[
          'selectedCrdBranches'
        ].value as any[]
        this.crdBranches = this.crdBranchesBase
        this.crdBranches = this.crdBranches.filter(
          (c) => selectedCrdBranches.indexOf(c) === -1,
        )
        this.crdBranches = selectedCrdBranches.concat(this.crdBranches)
        break
      }
      case SearchBySelectionEnum.SearchByRep: {
        const selectedReps = this.reportForm.controls['selectedReps']
          .value as any[]
        this.repList = this.repListBase
        this.repList = this.repList.filter(
          (r) => selectedReps.indexOf(r) === -1,
        )
        this.repList = selectedReps.concat(this.repList)
        break
      }
    }
  }

  searchSelectionChange(selectedSearchType: SearchBySelectionEnum) {
    switch (selectedSearchType) {
      case SearchBySelectionEnum.SearchByBranch:
        this.reportForm.controls['selectedReps'].setValue([])
        break
      case SearchBySelectionEnum.SearchByRep:
        this.reportForm.controls['selectedCrdBranches'].setValue([])
        break
          case SearchBySelectionEnum.SearchByAll:
        this.reportForm.controls['selectedCrdBranches'].setValue([])
        // Select every rep even though the Rep dropdown stays hidden for "All".
        this.reportForm.controls['selectedReps'].setValue(
          this.repListBase ? [...this.repListBase] : [],
        )
        break
    }
  }
  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    this.showToast('success', 'Please wait, your Excel is being downloaded.')
    component.save(options)
  }
  showTransactionControls() {
    this.selectedReportTypeSettings.showDates = true
    this.selectedReportTypeSettings.excludeTransactionsCheckbox = true
    this.showTransactionFilterSelection = true
  }

  hideTransactionControls() {
    this.selectedReportTypeSettings.showDates = false
    this.selectedReportTypeSettings.excludeTransactionsCheckbox = false
    this.showTransactionFilterSelection = false
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success')
        break
      case 'error':
        this.toastrService.error(message, 'Error')
        break
      case 'info':
        this.toastrService.info(message, 'Info')
        break
      case 'warning':
        this.toastrService.warning(message, 'Warning')
        break
      default:
        this.toastrService.show(message)
        break
    }
  }

  getAccessexportreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.reportService.getDeletedExportBlottersReports(Param).subscribe((r) => {
      if (Array.isArray(r) && r.length === 0) {
        this.showToast(
          'error',
          'Sorry there is no data. Please choose a date further back.',
        )
        return
      }
      this.gridExcelexportDeleted = r
      this.showToast(
        'success',
        'Please wait, We are retrieving your information',
      )
      setTimeout(() => this.returndata(component), 3000)
    })
  }
}

export class FormFieldSettings {
  public accountFormsRadioButtons: boolean
  public showDates: boolean
  public searchByRadioButtons: boolean
  public accountTransactionRadioButtons: boolean
  public excludeTransactionsCheckbox: boolean
  public excelPdfRadioButtons: boolean

  public reportTitle: string
  public searchSettings: ReportSearchSettings

  constructor(reportType: number) {
    this.searchSettings = null
    switch (reportType) {
      case 1:
        this.accountFormsRadioButtons = true
        this.showDates = false
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'Account Form Report'
        break
      case 2:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'Create Commission Report'
        break
      case 3:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'VA Age Report'
        break
      case 4:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'All Transactions Report'
        break
      case 5:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'Non-Rep Entered Transactions'
        break
      /* case 6:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'Summary of Non-Rep Entered Transactions'
        break */
      case 7:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'All Transactions Report Short'
        break
      case 8:
        this.accountFormsRadioButtons = false
        this.showDates = false
        this.searchByRadioButtons = true
        this.accountTransactionRadioButtons = true
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = true
        this.reportTitle = 'Create Account/Transaction Report'
        break
      case 9:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'VA Summary Report'
        break
      case 10:
        this.accountFormsRadioButtons = false
        this.showDates = true
        this.searchByRadioButtons = false
        this.accountTransactionRadioButtons = false
        this.excludeTransactionsCheckbox = false
        this.excelPdfRadioButtons = false
        this.reportTitle = 'Deleted Blotter Transactions'
        break
    }
  }
}

export class ReportSearchSettings {
  public searchBySelection: SearchBySelectionEnum
  public reportTypeSelection: SearchReportTypeEnum
  public fileTypeSelection: SearchReportFileTypeEnum

  constructor() {
    this.searchBySelection = SearchBySelectionEnum.SearchByRep
    this.reportTypeSelection = SearchReportTypeEnum.AccountReport
    this.fileTypeSelection = SearchReportFileTypeEnum.Excel
  }
}

export enum SearchBySelectionEnum {
  SearchByBranch,
  SearchByRep,
  SearchByAll,
}

export enum SearchReportTypeEnum {
  AccountReport,
  TransactionReport,
}

export enum SearchReportFileTypeEnum {
  Excel,
  Pdf,
}
